import React from 'react'
import { connect } from 'react-redux'
import ProductActions from '../../Redux/ProductRedux'
import FilesActions from '../../Redux/FilesRedux'
import FileUploader from '../FileUploader'

class UpdateImage extends React.Component {
  constructor (props) {
    super(props)
    let countries = []
    props.country_list.map((item, i) => {
      countries[i] = {
        value: item.id,
        label: item.name
      }
      return countries
    })

    this.countries = countries

    this.state = {
      form: {
        title: props.detail.title || '',
        description: props.detail.description || '',
        price: props.detail.price || 0,
        currency_code: props.detail.currency_code || 'IDR',
        image_file: '',
        product_type: props.detail.product_type || 'modem',
        status: props.detail.status || 'active',
        iso_code: props.detail.iso_code || '',
        details: {
          country_id: props.detail.details.country_id || ''
        }
      },
      country: '',
      file: null,
      uploaded: false
    }
  }

  componentDidMount = () => {
    this.props.resetFile()
  }

  componentWillReceiveProps = (newProps) => {
    if (newProps.files.data) {
      let form = { ...this.state.form }
      form.image_file = newProps.files.data.upload[0].filename
      this.setState({ form })
    }
  }

  _fileSelect = (event) => {
    const file = event.target
    this.setState({ file })
  }

  _upload = (event) => {
    event.preventDefault()
    let data = new FormData()
    data.append('files', this.state.file.files[0])
    data.append('type', 'product')
    data.append('product_type', this.state.form.product_type)

    this.props.upload(data)
    this.setState({ uploaded: true })
  }

  _fileUploaded = (filename, field) => {
    let form = { ...this.state.form }
    form[field] = filename
    this.setState({ form })
  }

  _submit = (event) => {
    event.preventDefault()
    let form = { ...this.state.form }
    const data = {
      id: this.props.detail.id,
      form
    }
    this.props.submit(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    // const { files } = this.props

    return (
      <div className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Edit Product Image</h4>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group text-center'>
            <label className='control-label'>Current Image</label>
            <br />
            <img alt={this.props.detail.image_file} title={this.props.detail.image_file} className='img img-responsive img-border' style={{ width: '100%' }} src={this.props.detail.image_url} />
          </div>
          <div className='form-group'>
            <div className='row'>
              <div className='col-3'>
                <label htmlFor='image' className='control-label'>Image File (<span className='text-orange'>270x160</span>)</label>
              </div>
              <div className='col-9'>
                <FileUploader setting={{ type: 'product', product_type: this.state.form.product_type }} onUploaded={(filename) => this._fileUploaded(filename, 'image_file')} />
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' disabled={!this.state.form.image_file} className='btn btn-primary'>Save</button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  files: state.files,
  country_list: state.preset.dataCountries
})

const dispatchToProps = (dispatch) => ({
  upload: (data) => dispatch(FilesActions.filesUploadRequest(data)),
  resetFile: () => dispatch(FilesActions.filesUploadReset()),
  submit: (data) => dispatch(ProductActions.productUpdateRequest(data))
})

export default connect(stateToProps, dispatchToProps)(UpdateImage)



// WEBPACK FOOTER //
// ./src/Containers/Product/UpdateImage.js